import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <>
        <h1 className='main-heading'>Image Gallery</h1>
    </>
  )
}

export default Header